import { HelpVideo } from '../../../app/core/help/HelpVideo';

export const PrivateWritingHaug = HelpVideo(
    'PrivateWriting',
    'Editor / Features',
    'Private Writing',
    20010,
    'https://s.ludi.co/app/haug/20010-private-writing.mp4',
);


